import { api, RTKTags } from '@/store/api'

import Env from '../../../env/env'

import type {
  BatchSearchRequest,
  BatchSearchResponse,
} from './BatchSearch.types'

export const batchSearchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    submitBatchSearch: builder.mutation<
      BatchSearchResponse,
      BatchSearchRequest
    >({
      query: (request) => ({
        url: `${Env.REACT_APP_BASE_API_URL}/api/v1/batch/json-requests`,
        method: 'POST',
        body: request,
      }),
      invalidatesTags: [
        RTKTags.userInfo,
        RTKTags.monitoringCenter,
        RTKTags.workspaceDetails,
        RTKTags.workspaceCredits,
      ],
    }),
  }),
})

export const { useSubmitBatchSearchMutation } = batchSearchApi
